"use client";

import { logoutAction } from "@/features/auth/actions";
import { clearAllDrafts } from "@/lib/drafts";

/** Signing out also drops this tab's unsaved drafts (shared-ui-kit.md rule 24). */
export function signOut() {
  clearAllDrafts();
  return logoutAction();
}
